/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/services/RepresentanteLegal/index.ts
 * Papel: camada de API (endpoints congelados)
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */


import { AxiosResponse } from 'axios'
import { api } from '../../../../../../../services/api'

import { localConfig } from '../../Configs/localConfig'

export interface TypeRepresentanteLegal {
  itens: [RepresentanteLegalItens]
}

export interface RepresentanteLegalItens {
  cod?: number
  cod_cliente?: number
  cod_conta?: number
  cod_usu?: number
  participacao?: string
  observacao?: string
  status?: number
  representante?: number | boolean
  cei?: number
  solicitante?: string
  usuario_nome?: string
  conta_nome?: string
  cliente_nome?: string
  assinatura?: string
  assinatura_base64?: string
}

export const getRepresentanteLegal = async (cod, codCliente) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso

  const response: AxiosResponse<TypeRepresentanteLegal> = await api.get(
    `/representante-legal?codConta=${config.conta}&codCliente=${codCliente === '' ? config.codCliente : codCliente
    }&cod=${cod}&pagination=-1`
  )

  return response
}

export const getRepresentanteLegalAssinatura = async (codUsuario, arquivo, codCliente) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso

  const response: AxiosResponse<TypeRepresentanteLegal> = await api.get(
    `/representante-legal/visualizar/arquivo/${arquivo}?codUsuario=${codUsuario}&codConta=${config.conta
    }&codCliente=${codCliente === '' ? config.codCliente : codCliente}`
  )

  return response
}

export const postRepresentanteLegal = async (data, codCliente) => {
  const config = localConfig()

  const response: AxiosResponse<TypeRepresentanteLegal> = await api.post(
    `/representante-legal?codConta=${config.conta}&codCliente=${codCliente === '' ? config.codCliente : codCliente
    }`,
    data
  )

  return response
}

export const putRepresentanteLegal = async (cod, data, codCliente) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso
  api.defaults.headers['Content-Type'] = 'application/json'

  const response: AxiosResponse<TypeRepresentanteLegal> = await api.put(
    `/representante-legal/${cod}?codConta=${config.conta}&codCliente=${codCliente === '' ? config.codCliente : codCliente
    }`,
    data
  )

  return response
}

export const delRepresentanteLegal = async (cod, codCliente) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso

  const response: AxiosResponse<TypeRepresentanteLegal> = await api.delete(
    `/representante-legal/${cod}?codConta=${config.conta}&codCliente=${codCliente === '' ? config.codCliente : codCliente
    }`
  )

  return response
}
